import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_INVENTORY_LISTING,
    ADD_INVENTORY,
    UPDATE_INVENTORY,
    UPDATE_LOWTHRESHOLD,
    EXPORT_INVENTORY,
    EXPORT_INVENTORY_LOG,
    GET_INVENTORY_DETAILS,
} from "./actionTypes.js";

import {
    getInventoryListingSuccess,
    getInventoryListingFail,
    getInventoryDetailsSuccess,
    createInventorySuccess,
    createInventoryFail,
    updateInventorySuccess,
    updateInventoryFail,
    updateLowTresholdSuccess,
    updateLowTresholdFail,
    exportInventorySuccess,
    exportInventoryFail,
    exportInventoryLogSuccess,
    exportInventoryLogFail,
    getInventoryDetailsFail,
} from "./actions.js";

import {
    inventoryListingApi,
    inventoryDetailsApi,
    addInventoryApi,
    updateInventoryApi,
    updateLowTresholdApi,
    exportInventoryApi,
    exportInventoryLogApi,
} from "./inventoryApi.js";

function* fetchInventoryListing({ payload }) {
    try {
        const response = yield call(inventoryListingApi, payload);
        yield put(getInventoryListingSuccess(response));
    } catch (error) {
        yield put(getInventoryListingFail(error));
    }
}

function* fetchInventoryDetail({ payload }) {
    try {
        const response = yield call(inventoryDetailsApi, payload);
        yield put(getInventoryDetailsSuccess(response));
    } catch (error) {
        yield put(getInventoryDetailsFail(error));
    }
}

function* createInventory({ payload }) {
    try {
        const response = yield call(addInventoryApi, payload);
        yield put(createInventorySuccess(response));
    } catch (error) {
        yield put(createInventoryFail(error));
    }
}

function* updateInventory({ payload }) {
    try {
        const response = yield call(updateInventoryApi, payload);
        yield put(updateInventorySuccess(response));
    } catch (error) {
        yield put(updateInventoryFail(error));
    }
}

function* updateLowTreshold({ payload }) {
    try {
        const response = yield call(updateLowTresholdApi, payload);
        yield put(updateLowTresholdSuccess(response));
    } catch (error) {
        yield put(updateLowTresholdFail(error));
    }
}

function* exportInventory({ payload }) {
    try {
        const response = yield call(exportInventoryApi, payload);
        yield put(exportInventorySuccess(response));
    } catch (error) {
        yield put(exportInventoryFail(error));
    }
}

function* exportInventoryLog({ payload }) {
    try {
        const response = yield call(exportInventoryLogApi, payload);
        yield put(exportInventoryLogSuccess(response));
    } catch (error) {
        yield put(exportInventoryLogFail(error));
    }
}

function* InventorySaga() {
    yield takeEvery(GET_INVENTORY_LISTING, fetchInventoryListing);
    yield takeEvery(GET_INVENTORY_DETAILS, fetchInventoryDetail);
    yield takeEvery(ADD_INVENTORY, createInventory);
    yield takeEvery(UPDATE_INVENTORY, updateInventory);
    yield takeEvery(UPDATE_LOWTHRESHOLD, updateLowTreshold);
    yield takeEvery(EXPORT_INVENTORY, exportInventory);
    yield takeEvery(EXPORT_INVENTORY_LOG, exportInventoryLog);

}

export default InventorySaga
